export enum ExtraDetailsKeys {
  AccessNotes = "AccessNotes",
}
